import Api from '../../shared/services/api'

const baseUrl = "expensereceipts";
export default {

  get() {
    return Api().get(baseUrl);
  },
  typeHead(searchTerm, all) {
    return Api().get(`${baseUrl}/typeHead?${searchTerm}&all=${all}`);
  },
  byId(id) {
    return Api().get(`${baseUrl}/${id}`);
  },
  query(options) {
    const qParams = new URLSearchParams(options);
    return Api().get(`${baseUrl}?${qParams.toString()}`);
  },
  updateState(state) {
    return Api().put(`${baseUrl}/state`, state);
  },
  edit(entity) {

    if (entity.id) return Api().put(`${baseUrl}/${entity.id}`, entity);
    return this.add(entity);
  },
  add(entity) {
    return Api().post(baseUrl, entity);
  },
  delete(id) {
    return Api().delete(`${baseUrl}/${id}`);
  }
}